import axios from "axios";
import TokenService from "./autentication/token.service";
import MenuService from "./menu/menu.service";


const baseUrl = process.env.REACT_APP_SERVER_ENDPOINT;
const mainSiteUrl = process.env.REACT_APP_MVC_URL;

// Flag to prevent multiple simultaneous logout redirects
let isLoggingOut = false;

const instance = axios.create({
  baseURL: baseUrl,
  headers: {
    "Content-Type": "application/json",
  },
});

instance.interceptors.request.use(
  (config: any) => {
    const token = TokenService.getLocalAccessToken();
    if (token) {
      config.headers["Authorization"] = 'Bearer ' + token;  
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);    

instance.interceptors.response.use(function (response: any) {
  return response
}, function (error) {
  const status = error?.response?.status || 0
  const resBaseURL = error?.response?.config?.baseURL
  
  // Handle unauthorized access - only if we haven't already started logging out
  if (resBaseURL === baseUrl && (status === 401 || status === 403) && !isLoggingOut) {
    const token = TokenService.getLocalAccessToken();
    
    // Only logout if user was actually logged in
    if (token) {
      isLoggingOut = true;
      
      // Clear menu cache before removing user data
      MenuService.clearMenuCache();
      
      TokenService.removeUser();
      localStorage.clear();
      
      if (mainSiteUrl) {
        window.location.assign(mainSiteUrl);
      }
       else {
        window.location.href = "/login";
      }
    }
  }
  
  return Promise.reject(error)
});

export const publicApi = instance;
export default instance;